/**
 * tenantRoleConfig.js
 *
 * Single source of truth for the Student Tenant "Industry Career Accelerator" track.
 *
 * Each entry has:
 *   value    — the string stored in the DB (bootcamp_enrollments.role) and sent
 *              in the enrollment API payload.  Must match a key in the backend
 *              roleMapping (individualRolesController.js).
 *   label    — the user-facing label shown in the dropdown.
 *   jsonFile — the public/individualroles/{jsonFile}.json that will be loaded.
 *              Kept here for reference; the authoritative resolver lives in the
 *              backend roleMapping, but having it here prevents future drift.
 *
 * To add a new student-tenant role:
 *   1. Add an entry here.
 *   2. Add a matching key in individualRolesController.js → roleMapping.
 *   3. Ensure the JSON file exists at public/individualroles/{jsonFile}.json.
 */

export const STUDENT_TENANT_ROLES = [
  {
    value:    'Full-Stack Engineer',
    label:    'Full-Stack Engineer',
    jsonFile: 'Full-Stack Engineer',      // Full-Stack Engineer.json  ✓ exists
  },
  {
    value:    'AI Engineer',
    label:    'AI Engineer',
    jsonFile: 'Artificial intelligence Engineer', // Artificial intelligence Engineer.json ✓ exists
  },
  {
    value:    'ML Engineer',
    label:    'ML Engineer',
    jsonFile: 'ML Engineer',              // ML Engineer.json  ✓ exists
  },
  {
    value:    'AI Full Stack Developer',
    label:    'AI Full Stack Developer',
    jsonFile: 'AI Full Stack Developer',  // AI Full Stack Developer.json  ✓ exists
  },
  {
    value:    'Cyber Security Analyst',
    label:    'Cyber Security Analyst',
    jsonFile: 'Cyber Security Analyst',   // Cyber Security Analyst.json  ✓ exists
  },
  {
    value:    'Automation Test Engineer',
    label:    'Automation Test Engineer',
    jsonFile: 'QA Tester',               // QA Tester.json  ✓ exists
  },
];

/** Set of valid submission values — used for frontend validation. */
export const STUDENT_TENANT_ROLE_VALUES = new Set(
  STUDENT_TENANT_ROLES.map((r) => r.value)
);
